import { useFilePicker } from 'use-file-picker';
import Button from '@ui/Button';
import Input from '@ui/Input';
import React, { useRef } from 'react';
import * as yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Typography from '@ui/Typography';
import Link from '@ui/Link';
import Select from '@ui/Select';
import { getAllISOCodes } from 'iso-country-currency';
import { sortBy } from 'lodash-es';
import TextArea from '@ui/TextArea';
import Avatar from '@ui/Avatar';
import { FaUser } from 'react-icons/fa';
import Slider from '@ui/Slider';
import AvatarEditor from '@ui/AvatarEditor';

function JoinFormEditAvatarStep(props) {
  const { image, onSubmit } = props;
  const [editor, setEditor] = React.useState(null);
  const setEditorRef = (e) => setEditor(e);

  const handleSave = () => {
    if (editor) {
      const canvas = editor.getImageScaledToCanvas();
      canvas.toBlob((blob) => {
        const editedImage = new File([blob], 'edited-image.png', {
          type: 'image/png',
        });
        onSubmit(editedImage);
      }, 'image/png');
    }
  };

  return (
    <div className="flex flex-col gap-12 flex-1 w-full">
      <Typography variant="h1" component="h2">Edit Profile Picture</Typography>
      <div className="flex flex-col gap-6">
        <AvatarEditor image={image} setEditorRef={setEditorRef} />
        <Button
          variant="filled"
          color="primary"
          type="button"
          onClick={handleSave}>
          Save
        </Button>
      </div>
    </div>
  );
}

export default JoinFormEditAvatarStep;
